/**
 * Created by igor.kulishov on 9/23/2016.
 */
(function(){

    'use strict';

    angular
        .module('app.vehicledetails')
        .factory('VidDetailsService', ['CacheSearchParams', '$http', '$q', function(cacheSearchParams, $http, $q){

            //need to modify to use with promise
            var url;
            var vidArray = [];
            var tempVidArray = [];
            var nextVid = '';
            var previousVid = '';
            var nextPreviousVids = {
                nextVid: nextVid,
                previousVid: previousVid
            };
            var paginationStep;
            var current_st;
            var maxModelsFound;
            var maxCurrentPageNumber;
            var maxSt;


            return {
                getNextAndPreviousVids: function(currentVid, leaveVdpFlag) {

                    if (leaveVdpFlag = 'leaveVdpFlag' && !currentVid) {
                        vidArray = [];
                        url = '';
                        current_st = null;
                        return;
                    }

                    var deferred = $q.defer();

                    // for the first VDP page load
                    if ( !checkIfVidInArray(currentVid) ) {
                        updateVidArray().then(
                            function (res) {

                                checkAndUpdateNextPreviousVids(currentVid).then(function(res) {
                                    nextPreviousVids = res;
                                    deferred.resolve(nextPreviousVids);
                                }, function(err) {
                                    console.error('err', err);
                                });

                            }, function (err) {
                                console.error('err', err);
                            }
                        );

                        // if first item
                    } else if ( checkIfFirst (currentVid) || checkIfLast(currentVid) ) {

                        checkAndUpdateNextPreviousVids(currentVid).then(function(res) {
                            nextPreviousVids = res;
                            deferred.resolve(nextPreviousVids);

                        }, function(err) {
                            console.error('err', err);
                        });

                    } else {

                        nextPreviousVids = buildNextPreviousVids(currentVid);
                        deferred.resolve(nextPreviousVids);
                    }

                    return deferred.promise;
                }
            };
            
            function updateVidArray (nextPrevUrlCommand){

                var cacheServiceParams = cacheSearchParams.storeLastSearchParams();
                url = cacheServiceParams.searchCallbackUrl;
                maxModelsFound = parseInt(cacheServiceParams.maxModelsFound);
                if (cacheServiceParams.params.st) {
                    current_st = parseInt(cacheServiceParams.params.st);
                } else {
                    current_st = 0;
                }

                if (cacheServiceParams.params.sz) {
                    paginationStep = parseInt(cacheServiceParams.params.sz);
                } else {
                    paginationStep = 100;
                }


                maxSt = Math.floor(maxModelsFound / paginationStep) *  paginationStep;

                // for 'paginating' to next/previous srp page
                if (nextPrevUrlCommand && url) {

                    // define url for the next srp page for 'next' button click
                    if (nextPrevUrlCommand === 'nextSrpPageUrl') {

                        if (current_st == 0) {
                            url = url + '&st=' + paginationStep;
                            current_st = paginationStep;
                            cacheSearchParams.storeLastSearchParams('', '' , url, current_st);

                        } else if(current_st == maxSt) {
                            // do nothing: last page
                            // console.error('last page');
                        } else {
                            var old_st = current_st;
                            current_st = parseInt(current_st) + parseInt(paginationStep);
                            url = url.replace( 'st=' + old_st , 'st=' + current_st );
                            cacheSearchParams.storeLastSearchParams('', '' , url, current_st);
                        }

                    // define url for previous srp for 'previuos' button click
                    } else if (nextPrevUrlCommand === 'previousSrpPageUrl') {

                        if (current_st == 0) {
                            // do nothing: first page
                            // console.error('last page');
                        } else {
                            var old_st = current_st;
                            current_st = parseInt(current_st) - parseInt(paginationStep);
                            url = url.replace( 'st=' + old_st , 'st=' + current_st );
                            cacheSearchParams.storeLastSearchParams('', '' , url, current_st);
                        }

                    }

                } else if (!nextPrevUrlCommand && url) {

                    // keep the same params for first time load..

                } else {
                    //error handling : no url params
                    console.error('error: no URL parameter');
                }

                return $http({
                    headers: {
                        'Accept': '*/*',
                        'Content-Type': 'application/json'
                    },
                    url: url,
                    method: 'JSONP',
                    params: {callback: "JSON_CALLBACK"},
                    withCredentials: true
                }).then(function(res) {
                    res.data.docs.map(function (doc) {
                        if (vidArray.indexOf(doc.VEHICLE_ID) === -1) {
                            tempVidArray.push(doc.VEHICLE_ID);
                        }
                    });

                    maxCurrentPageNumber = current_st + tempVidArray.length;

                    if (nextPrevUrlCommand === 'nextSrpPageUrl') {
                        vidArray = vidArray.concat(tempVidArray);
                    }

                    else if (nextPrevUrlCommand === 'previousSrpPageUrl') {
                        vidArray = tempVidArray.concat(vidArray);
                    }

                    else {
                        vidArray = tempVidArray;
                    }

                    tempVidArray = [];

                    return;

                }, function(err) {
                    console.error('error: ', err);
                });



            }

            function checkIfFirst ( vid ) {
                return  parseInt( vid ) === parseInt( vidArray[0]) ;
            }

            // check if element is last on the current page but not last car for the entire search results
            function checkIfLast ( vid ) {
                return ( parseInt ( vid ) === parseInt( vidArray[vidArray.length - 1] ) && (maxModelsFound !== maxCurrentPageNumber) );
            }

            function checkIfVidInArray ( vid ) {
                return vidArray.indexOf( vid ) > -1 ;
            }

            function buildNextPreviousVids(currentVid) {


                if ( checkIfFirst(currentVid) ) {
                    previousVid = '';
                } else {
                    previousVid = vidArray[vidArray.indexOf(currentVid) - 1];
                }

                if ( checkIfLast(currentVid) ) {
                    nextVid = '';
                } else {
                    nextVid = vidArray[vidArray.indexOf(currentVid) + 1];
                }

                return {
                    nextVid: nextVid,
                    previousVid: previousVid
                };

            }

            function checkAndUpdateNextPreviousVids(currentVid) {

                var nextPrevDeferred = $q.defer();

                if ( checkIfFirst(currentVid) ) {

                    updateVidArray('previousSrpPageUrl').then(
                        function (res) {

                            nextPreviousVids = buildNextPreviousVids(currentVid);
                            nextPrevDeferred.resolve(nextPreviousVids);

                        }, function (err) {
                            console.error('err', err);
                        }
                    );

                }

                else if ( checkIfLast (currentVid) ) {

                    updateVidArray('nextSrpPageUrl').then(
                        function (res) {

                            nextPreviousVids = buildNextPreviousVids(currentVid);
                            nextPrevDeferred.resolve(nextPreviousVids);

                        }, function (err) {
                            console.error('err', err);
                        }
                    );

                } else {

                    nextPreviousVids = buildNextPreviousVids(currentVid);
                    nextPrevDeferred.resolve(nextPreviousVids);
                }

                return nextPrevDeferred.promise;

            }

        }]);
})();


// WEBPACK FOOTER //
// ./app/vehicledetails/services/VidDetailsService.js